import { Lock, Play, Crown } from "lucide-react";
import { mediaSrc } from "@/lib/api";

export default function PostTile({ post, onOpen, index = 0 }) {
  return (
    <button onClick={() => onOpen(post)} data-testid={`post-tile-${post.id}`} style={{ animationDelay: `${index * 40}ms` }}
      className="group rise-in relative aspect-[9/16] overflow-hidden rounded-md border border-[#2A2E37] bg-[#121418] transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-white/25">
      {post.locked ? (
        <>
          {post.creator.avatar_url && <img src={mediaSrc(post.creator.avatar_url)} alt="" className="absolute inset-0 h-full w-full scale-125 object-cover blur-xl" />}
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-black/60 backdrop-blur-md" data-testid="post-tile-locked">
            <Lock className="h-7 w-7 text-[#FF2E4D]" />
            <span className="text-xs font-semibold uppercase tracking-wider text-gray-200">Subscribers</span>
          </div>
        </>
      ) : post.cover_src ? (
        <img src={mediaSrc(post.cover_src)} alt={post.caption} loading="lazy" data-testid="post-tile-cover"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      ) : post.media_type === "video" ? (
        <video src={`${mediaSrc(post.media_src)}#t=0.5`} muted playsInline preload="metadata" className="h-full w-full object-cover" />
      ) : (
        <img src={mediaSrc(post.media_src)} alt={post.caption} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      )}
      <div className="absolute left-2 top-2 flex gap-1">
        {post.media_type === "video" && !post.locked && <span className="rounded-full bg-black/50 p-1"><Play className="h-3 w-3 fill-white" /></span>}
        {post.is_premium && <span className="rounded-full bg-[#FF2E4D] p-1"><Crown className="h-3 w-3" /></span>}
      </div>
    </button>
  );
}
